import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {LicenseManager} from 'ag-grid-enterprise/main';
import PerfectScrollbar from 'perfect-scrollbar';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));

LicenseManager.setLicenseKey('Velocity_Capital,_LLC_MultiApp_1Devs14_October_2020__MTYwMjYzMDAwMDAwMA==445d54ace2f63442caf5facefe2a27c3');
